module.exports = __webpack_public_path__ + "img/icon_meteo_01.7a95bdde.svg";